import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";

const HistoricalDataAndTrends = () => {
  const data = [
    { month: 'January', commissionFee: '$250', paymentProcessingFee: '$40', shippingFee: '$80', advertisingFee: '$50', returnFee: '$30', otherFee: '$0', totalFee: '$450' },
    { month: 'February', commissionFee: '$250', paymentProcessingFee: '$40', shippingFee: '$80', advertisingFee: '$50', returnFee: '$30', otherFee: '$0', totalFee: '$450' },
    { month: 'March', commissionFee: '$250', paymentProcessingFee: '$40', shippingFee: '$80', advertisingFee: '$50', returnFee: '$30', otherFee: '$0', totalFee: '$450' },
    { month: 'April', commissionFee: '$250', paymentProcessingFee: '$40', shippingFee: '$80', advertisingFee: '$50', returnFee: '$30', otherFee: '$0', totalFee: '$450' },
    { month: 'May', commissionFee: '$250', paymentProcessingFee: '$40', shippingFee: '$80', advertisingFee: '$50', returnFee: '$30', otherFee: '$0', totalFee: '$450' },
  ];

  const columns = [
    { name: 'Month', selector: row => row.month },
    { name: 'Commision Fee', selector: row => row.commissionFee, minWidth: "140px" },
    { name: 'Payment Processing fee', selector: row => row.paymentProcessingFee, minWidth: "200px" },
    { name: 'Shipping Fee', selector: row => row.shippingFee, minWidth: "140px" },
    { name: 'Advertising fee', selector: row => row.advertisingFee, minWidth: "140px" },
    { name: 'Return fee', selector: row => row.returnFee, minWidth: "120px" },
    { name: 'Other fee', selector: row => row.otherFee },
    { name: 'Total fees', selector: row => row.totalFee },
  ];

  return (
    <section>
      <div className="fw-semibold fs-5 mt-3 mb-2">
        Historical Data and Trends
      </div>
      <DatatableComponent data={data} columns={columns} type={"darkGray"} />
    </section>
  );
};

export default HistoricalDataAndTrends;